// src/components/Header/Header.tsx
import React, { useState } from 'react';
import styles from './GetInTouch.module.css';
import emailjs from '@emailjs/browser';
import Alert from '../Alert';
import { useTranslation } from 'react-i18next';
import carte from '../../assets/images/carte.jpeg';


type AlertState = {
  show: boolean;
  message: string;
  title: string;
};
const GetInTouch: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    subject: '',
    email: '',
    message: ''
  });


  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const [alert, setAlert] = useState<AlertState>({
    show: false,
    title: '',
    message: ''

  })
  const handleSubmit = (e: any) => {
    e.preventDefault();

    emailjs.send(
      'service_h6da6o9', // EmailJS Service ID
      'template_j6hjmge', // EmailJS Template ID
      formData,
      'aTWZpD3yjtEhy1KWS'  // EmailJS User ID (Public Key)
    )
      .then(() => {
        setAlert({
          show: true,
          title: t('messageTitle'),
          message: t('messageGetInTouch')

        });
        setFormData({ subject: '', email: '', message: '' });
      })
      .catch(() => {

        setAlert({
          show: true,
          message: t('messageDescription'),
          title: t('joinMessageFailedTitle')
        });
      });
  };

  return (

    <div className={styles.infoSection} id="contact">
      {alert.show && (
        <Alert
          message={alert.message}
          title={alert.title}
          onClose={() => setAlert(prev => ({ ...prev, show: false }))}
        />
      )}
      <div >
        <h3 className={styles.infoTitle}>
          <span>{t('getInTouch')}</span>
        </h3>
        <p className={`${styles.infoDescription} ${i18n.language === 'ar' ? styles.arabic : ''}`}>
          {t("getInTouchDescription")}
        </p>
      </div>
      <div className={styles.infoCardsContent}>
        {/* MAP */}
        <div className={styles.mapContainer}>
          {/* <iframe
  title="Google Map - Nos Bureaux"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3247.847181987844!2d11.029569875436328!3d35.5080567726436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x130223004dd411fb%3A0x1b75ca032be42ee6!2sSte%20carottage%20sciage%20pro!5e0!3m2!1sen!2stn!4v1784236685471!5m2!1sen!2stn" 
  width="100%"
  height="100%"
  style={{ border: 0 }}
  loading="lazy"
  allowFullScreen
></iframe> */}
<img
        src={carte} // Path to your saved map image
        alt="Carte de localisation - Ste Carottage Sciage Pro (Tunis, Sousse, Mahdia)"
        className={styles.mapImage}
        loading="lazy"
      />
        </div>

        <form className={styles.contactForm} onSubmit={handleSubmit}>
          {/* Email */}
          <div className={styles.formGroup}>

            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`${styles.formInput} ${i18n.language === 'ar' ? styles.arabic : ''}`}
              placeholder={t('enterEmail')}
              required
            />
          </div>

          {/* Subject */}
          <div className={styles.formGroup}>

            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              className={`${styles.formInput} ${i18n.language === 'ar' ? styles.arabic : ''}`}
              placeholder={t('subject')}
              required
            />
          </div>

          {/* Message */}
          <div className={styles.formGroup}>

            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              className={`${styles.formInput} ${styles.formTextarea} ${i18n.language === 'ar' ? styles.arabic : ''}`}
              placeholder={t('yourMessage')}
              rows={5}
              required
            />
          </div>
          {/* Submit Button */}
          <button type="submit" className={styles.submitButton}>
            {t('submit')}
          </button>
        </form>
      </div>
    </div>
  );
}

export default GetInTouch;
